export default "dist/images/4e0e750f2f09de58219773edd46cbbf5.png";